import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.58 23.58"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#fff" }, [
      _createElementVNode("path", { d: "M11.79 23.58C5.29 23.58 0 18.29 0 11.79S5.29 0 11.79 0s11.79 5.29 11.79 11.79-5.29 11.79-11.79 11.79Zm0-22.69C5.78.89.89 5.78.89 11.79s4.89 10.9 10.9 10.9 10.9-4.89 10.9-10.89S17.8.89 11.79.89Z" }),
      _createElementVNode("path", { d: "M6.65 9.26H9v7.58H6.65zM7.81 8.27c.77 0 1.39-.63 1.39-1.4s-.62-1.4-1.39-1.4-1.39.63-1.39 1.4.62 1.4 1.39 1.4ZM12.75 12.86c0-1.07.49-1.7 1.43-1.7.86 0 1.28.61 1.28 1.7v3.98h2.34v-4.8c0-2.03-1.15-3.01-2.76-3.01s-2.29 1.25-2.29 1.25V9.26H10.5v7.58h2.25v-3.98Z" })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "LinkedIn"}) } }